import type { ReactNode } from "react";

type Tone = "neutral" | "orange" | "green" | "amber" | "red" | "blue";

const tones: Record<Tone, string> = {
  neutral: "bg-zinc-100 text-zinc-700 ring-zinc-200/50",
  orange: "bg-ktm-orange-50 text-ktm-orange-700 ring-ktm-orange-100",
  green: "bg-emerald-50 text-emerald-700 ring-emerald-200/50",
  amber: "bg-amber-50 text-amber-800 ring-amber-200/50",
  red: "bg-red-50 text-red-700 ring-red-200/50",
  blue: "bg-sky-50 text-sky-700 ring-sky-200/50",
};

export function Badge({
  tone = "neutral",
  children,
  className = "",
}: {
  tone?: Tone;
  children: ReactNode;
  className?: string;
}): JSX.Element {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${tones[tone]} ${className}`}
    >
      {children}
    </span>
  );
}
